/**
 * Available permissions in the system
 */
class Permissions {
  public static readonly Employee = class {
    static readonly Create: string = 'employee:create';
    static readonly Read: string = 'employee:read';
    static readonly Update: string = 'employee:update';
    static readonly Delete: string = 'employee:delete';
    static readonly ViewPin: string = 'employee:view_pin';
  };

  public static readonly Foreman = class {
    static readonly Create: string = 'foreman:create';
    static readonly Read: string = 'foreman:read';
    static readonly Update: string = 'foreman:update';
    static readonly Delete: string = 'foreman:delete';
  };

  public static readonly Hardware = class {
    static readonly SeePriceColumns: string = 'hardware:see_price_columns';
  };

  /**
   * Sync permission for data synchronization operations
   */
  static readonly Sync: string = 'sync';

  /**
   * General admin access permission
   */
  static readonly AdminAccess: string = 'admin:access';
}

export default Permissions;

/**
 * Role-based permissions mapping
 */
export const ROLE_PERMISSIONS: Record<string, string[]> = {
  admin: [
    Permissions.Employee.Create,
    Permissions.Employee.Read,
    Permissions.Employee.Update,
    Permissions.Employee.Delete,
    Permissions.Employee.ViewPin,
    Permissions.AdminAccess,
    Permissions.Foreman.Create,
    Permissions.Foreman.Read,
    Permissions.Foreman.Update,
    Permissions.Foreman.Delete,
    Permissions.Sync,
    Permissions.Hardware.SeePriceColumns,
  ],
  logistic: [Permissions.Foreman.Read],
  user: [Permissions.Foreman.Read],
};
